// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"258":"ef5ef541","367":"6c598e60","540":"69c7a837","762":"a585b610","894":"f0b26951"}[chunkId] + ".css";
};